import { FreightsCompanyRequest, FreightsCompanyResponseModel } from "@gtpl/shared-models/masters";
import { connection } from "..";
import axios from "axios";

export class FreightsCompanytService {
    activatedeActivate(data: FreightsCompanyRequest) {
        throw new Error('Method not implemented.');
      }
      URL = connection.DEPLOY_URL + '/freights-company';
    
      async createFreightCompany(req:FreightsCompanyRequest): Promise<FreightsCompanyResponseModel> {
        return await axios.post(this.URL + '/createFreightCompany', req)
          .then(res => {
            return res.data
          })
      }
      async getAllFreightsCompanies(): Promise<FreightsCompanyResponseModel> {
        return await axios.post(this.URL + '/getAllFreightsCompanies')
          .then(res => {
            return res.data
          })
      }
      async updateFreightCompany(req:FreightsCompanyRequest): Promise<FreightsCompanyResponseModel> {
        return await axios.post(this.URL + '/updateFreightCompany',req)
            .then(res => {
                return res.data
            }) 
    }
    async getAllActiveFreightsCompanies(): Promise<FreightsCompanyResponseModel> {
        return await axios.post(this.URL + '/getAllActiveFreightsCompanies')
            .then(res => {
                return res.data
            }) 
    }
    async activateDeactivateFreightCompany(req:FreightsCompanyRequest): Promise<FreightsCompanyResponseModel> {
        return await axios.post(this.URL + '/activateDeactivateFreightCompany',req)
            .then(res => {
                return res.data
            }) 
    }
}